import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    alignSelf: 'flex-start',
  },
  shield: {},
  iconContainer: {
    position: 'absolute',
    top: 0,
    left: 0.5,
    bottom: 4,
    right: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    color: white,
  },
});
